const ns = "MODULES_MODULE";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
